import { useQuery } from '@tanstack/react-query';
import { getPricing } from '@/apis/getPricing';

export const usePricing = () => {
  return useQuery({
    queryKey: ['pricing'],
    queryFn: getPricing,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 3,
  });
};
